import React, { useState } from 'react';
import CookieConsent from 'react-cookie-consent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCookieBite, faTimes } from '@fortawesome/free-solid-svg-icons';

const CookieConsentBanner: React.FC = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <CookieConsent
      location="bottom-right"
      buttonText="Accepter"
      cookieName="mgeCookieConsent"
      style={{ 
        background: "#ffffff",
        color: "#333333",
        fontSize: "14px",
        padding: "0",
        alignItems: "center",
        width: expanded ? "320px" : "220px",
        maxWidth: "90vw",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "8px",
        margin: "20px",
        overflow: "hidden",
        transition: "all 0.3s ease",
        border: "1px solid #eaeaea",
        position: "fixed",
        bottom: "20px",
        right: "20px",
        left: "auto",
        zIndex: 9999,
      }}
      buttonStyle={{ 
        background: "#E41E26", 
        color: "#ffffff", 
        fontSize: "14px",
        padding: "8px 16px",
        borderRadius: "4px",
        fontWeight: "500",
        margin: "0 12px 12px 0",
        alignSelf: "flex-end",
      }}
      declineButtonStyle={{
        background: "transparent",
        border: "1px solid #E41E26",
        color: "#E41E26",
        fontSize: "14px",
        padding: "8px 16px",
        borderRadius: "4px",
        margin: "0 0 12px 0",
        alignSelf: "flex-end",
      }}
      contentStyle={{
        padding: "16px",
        flex: "1",
        display: "flex",
        flexDirection: "column",
      }}
      expires={150}
      enableDeclineButton
      declineButtonText="Refuser"
      onDecline={() => {
        console.log("Cookies refusés");
      }}
      ButtonComponent={({ style, ...props }: { style: React.CSSProperties; [key: string]: any }) => (
        <button style={{ ...style }} {...props}>
          {props.children}
        </button>
      )}
    >
      <div className="w-full">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center">
            <FontAwesomeIcon icon={faCookieBite} className="text-primary mr-2" />
            <h3 className="font-bold text-base">Cookies</h3>
          </div>
          {!expanded && (
            <button 
              onClick={() => setExpanded(true)}
              className="text-xs underline text-gray-500 hover:text-primary"
            >
              Plus d'infos
            </button>
          )}
          {expanded && (
            <button 
              onClick={() => setExpanded(false)}
              className="text-gray-500 hover:text-primary"
              aria-label="Réduire"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          )}
        </div>
        
        {expanded ? (
          <p className="text-xs text-gray-600 mb-3 w-full">
            Nous utilisons des cookies pour améliorer votre expérience. En continuant, vous acceptez notre politique de confidentialité.
          </p>
        ) : (
          <p className="text-xs text-gray-600 mb-3 w-full">
            Ce site utilise des cookies.
          </p>
        )}
      </div>
    </CookieConsent>
  );
};

export default CookieConsentBanner;
